export default __webpack_public_path__ + "static/media/tutorial-step-1-sweepstakes.91d3090d.png";